import Vue from 'vue'
import VueRouter from 'vue-router'

// 所有路由组件改为懒加载，提升首屏加载速度
// 首页组件可以同步加载（因为首次访问的就是首页）
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'YJSYIndex',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Index.vue')
  },
  {
    path: '/old-home',
    name: 'Home',
    component: Home
  },
  {
    path: '/marker-info',
    name: 'MarkerInfo',
    component: () => import(/* webpackChunkName: "marker" */ '@/views/MarkerInfo.vue')
  },
  {
    path: '/enterprises',
    redirect: '/emergency-enterprises'
  },
  {
    path: '/enterprises/:id',
    redirect: to => `/enterprise/${to.params.id}`
  },
  {
    path: '/products',
    name: 'ProductList',
    component: () => import(/* webpackChunkName: "product" */ '@/views/ProductList.vue')
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "product" */ '@/views/ProductDetail.vue')
  },
  {
    path: '/demands',
    name: 'EmergencyDemands',
    component: () => import(/* webpackChunkName: "demand" */ '@/views/EmergencyDemands.vue')
  },
  {
    path: '/demands/:id',
    name: 'DemandDetail',
    component: () => import(/* webpackChunkName: "demand" */ '@/views/DemandDetail.vue')
  },
  {
    path: '/emergency-enterprises',
    name: 'EmergencyEnterprises',
    component: () => import(/* webpackChunkName: "enterprise" */ '@/views/EmergencyEnterprises.vue')
  },
  {
    path: '/emergency-enterprises/:id',
    redirect: to => `/enterprise/${to.params.id}`
  },
  {
    path: '/enterprise/:id',
    name: 'EnterpriseDetail',
    component: () => import(/* webpackChunkName: "enterprise" */ '@/views/EnterpriseDetail.vue')
  },
  {
    path: '/thinktank',
    name: 'EmergencyThinktank',
    component: () => import(/* webpackChunkName: "thinktank" */ '@/views/EmergencyThinktank.vue')
  },
  {
    path: '/expert/:id',
    name: 'ExpertDetail',
    component: () => import(/* webpackChunkName: "thinktank" */ '@/views/ExpertDetail.vue')
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import(/* webpackChunkName: "article" */ '@/views/ArticleDetail.vue')
  },
  {
    path: '/classroom',
    name: 'SafetyClassroom',
    component: () => import(/* webpackChunkName: "classroom" */ '@/views/SafetyClassroom.vue')
  },
  {
    path: '/resources',
    name: 'Resources',
    component: () => import(/* webpackChunkName: "resources" */ '@/views/Resources.vue')
  },
  {
    path: '/aq-classroom/category',
    name: 'AqClassroomCategory',
    component: () => import(/* webpackChunkName: "classroom" */ '@/views/SafetyClassroom.vue')
  },
  {
    path: '/events',
    name: 'RealTimeEvents',
    component: () => import(/* webpackChunkName: "events" */ '@/views/RealTimeEvents.vue')
  },
  {
    path: '/events/:id',
    name: 'EventDetail',
    component: () => import(/* webpackChunkName: "events" */ '@/views/EventDetail.vue')
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import(/* webpackChunkName: "user" */ '@/views/UserCenter.vue')
  },
  {
    path: '/write-user-center',
    name: 'WriteUserCenter',
    component: () => import(/* webpackChunkName: "user" */ '@/views/WriteUserCenter.vue')
  },
  {
    path: '/publish-product',
    name: 'PublishProduct',
    component: () => import(/* webpackChunkName: "product" */ '@/views/PublishProduct.vue')
  },
  {
    path: '/invite-expert',
    name: 'InviteExpert',
    component: () => import(/* webpackChunkName: "expert" */ '@/views/InviteExpert.vue')
  },
  {
    path: '/expert-reply',
    name: 'ExpertReply',
    component: () => import(/* webpackChunkName: "expert" */ '@/views/ExpertReply.vue')
  },
  {
    path: '/publish-demand',
    redirect: '/write-user-center?action=publish-demand'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Register.vue')
  },
  {
    path: '/case/:id',
    name: 'CaseDetail',
    component: () => import(/* webpackChunkName: "case" */ '@/views/CaseDetail.vue')
  },
  {
    path: '/policy/:id',
    name: 'PolicyDetail',
    component: () => import(/* webpackChunkName: "events" */ '@/views/EventDetail.vue'),
    props: { contentType: 'policy' }
  },
  {
    path: '/announcement/:id',
    name: 'AnnouncementDetail',
    component: () => import(/* webpackChunkName: "announcement" */ '@/views/AnnouncementDetail.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import(/* webpackChunkName: "case" */ '@/views/Cases.vue')
  },
  {
    path: '/policies',
    name: 'Policies',
    component: () => import(/* webpackChunkName: "policy" */ '@/views/Policies.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import(/* webpackChunkName: "service" */ '@/views/Services.vue')
  },
  {
    path: '/service/:id',
    name: 'ServiceDetail',
    component: () => import(/* webpackChunkName: "service" */ '@/views/ServiceDetail.vue')
  },
  {
    path: '/standards',
    name: 'Standards',
    component: () => import(/* webpackChunkName: "standard" */ '@/views/Standards.vue')
  },
  {
    path: '/standard/:id',
    name: 'StandardDetail',
    component: () => import(/* webpackChunkName: "standard" */ '@/views/StandardDetail.vue')
  },
  {
    path: '/scenarios',
    name: 'Scenarios',
    component: () => import(/* webpackChunkName: "scenario" */ '@/views/Scenarios.vue')
  },
  {
    path: '/scenario/:id',
    name: 'ScenarioDetail',
    component: () => import(/* webpackChunkName: "scenario" */ '@/views/ScenarioDetail.vue')
  },
  {
    path: '/hazards',
    name: 'Hazards',
    component: () => import(/* webpackChunkName: "hazard" */ '@/views/Hazards.vue')
  },
  {
    path: '/hazard/:id',
    name: 'HazardDetail',
    component: () => import(/* webpackChunkName: "hazard" */ '@/views/HazardDetail.vue')
  },
  {
    path: '/plans',
    name: 'Plans',
    component: () => import(/* webpackChunkName: "plan" */ '@/views/Plans.vue')
  },
  {
    path: '/plan/:id',
    name: 'PlanDetail',
    component: () => import(/* webpackChunkName: "plan" */ '@/views/PlanDetail.vue')
  },
  {
    path: '/education',
    name: 'Education',
    component: () => import(/* webpackChunkName: "education" */ '@/views/Education.vue')
  },
  {
    path: '/education/:id',
    name: 'EducationDetail',
    component: () => import(/* webpackChunkName: "education" */ '@/views/EducationDetail.vue')
  },
  {
    path: '/dynamics',
    name: 'Dynamics',
    component: () => import(/* webpackChunkName: "dynamics" */ '@/views/Dynamics.vue')
  },
  {
    path: '/dynamics/:id',
    name: 'DynamicsDetail',
    component: () => import(/* webpackChunkName: "dynamics" */ '@/views/DynamicsDetail.vue')
  },
  {
    path: '/declarations',
    name: 'Declarations',
    component: () => import(/* webpackChunkName: "declaration" */ '@/views/Declarations.vue')
  },
  {
    path: '/declaration/:code',
    name: 'DeclarationDetail',
    component: () => import(/* webpackChunkName: "declaration" */ '@/views/DeclarationDetail.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '@/views/Support.vue')
  },
  {
    path: '/support/:id',
    name: 'SupportDetail',
    component: () => import(/* webpackChunkName: "support" */ '@/views/SupportDetail.vue')
  },
  // YJSY 相关路由
  {
    path: '/yjsy',
    redirect: '/'
  },
  {
    path: '/yjsy/policy',
    name: 'YJSYPolicy',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Policy.vue')
  },
  {
    path: '/yjsy/tech-showcase',
    name: 'YJSYTechShowcase',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/TechShowcase.vue')
  },
  {
    path: '/yjsy/education',
    name: 'YJSYEducation',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Education.vue')
  },
  {
    path: '/yjsy/transformation',
    name: 'YJSYTransformation',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Transformation.vue')
  },
  {
    path: '/yjsy/trading',
    name: 'YJSYTrading',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Trading.vue')
  },
  {
    path: '/yjsy/warning',
    name: 'YJSYWarning',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Warning.vue')
  },
  {
    path: '/yjsy/training',
    name: 'YJSYTraining',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/Training.vue')
  },
  {
    path: '/yjsy/public-welfare',
    name: 'YJSYPublicWelfare',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/PublicWelfare.vue')
  },
  {
    path: '/yjsy/public-welfare-resources',
    name: 'PublicWelfareResources',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/PublicWelfareResources.vue')
  },
  {
    path: '/yjsy/scenario-detail',
    name: 'YJSYScenarioDetail',
    component: () => import(/* webpackChunkName: "yjsy" */ '@/views/YJSY/ScenarioDetail.vue')
  },
  {
    path: '/content/leadership-care',
    name: 'LeadershipCare',
    component: () => import(/* webpackChunkName: "leadership" */ '@/views/LeadershipCare.vue')
  },
  {
    path: '/leadership-care/:id',
    name: 'LeadershipCareDetail',
    component: () => import(/* webpackChunkName: "leadership" */ '@/views/LeadershipCareDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

// 捕获并忽略导航重复错误和导航取消错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 忽略导航重复错误
    if (err.name === 'NavigationDuplicated' || err.message?.includes('Avoided redundant navigation')) {
      return Promise.resolve()
    }
    // 忽略导航取消错误（通常发生在快速切换路由时）
    if (err.name === 'NavigationCancelled' || err.message?.includes('Navigation cancelled')) {
      return Promise.resolve()
    }
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    // 忽略导航重复错误
    if (err.name === 'NavigationDuplicated' || err.message?.includes('Avoided redundant navigation')) {
      return Promise.resolve()
    }
    // 忽略导航取消错误（通常发生在快速切换路由时）
    if (err.name === 'NavigationCancelled' || err.message?.includes('Navigation cancelled')) {
      return Promise.resolve()
    }
    return Promise.reject(err)
  })
}

export default router 